var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "terms-dialog", staticStyle: { padding: "20px" } },
    [
      !_vm.$vlastMode && _vm.$userIsClient
        ? _c("div", [
            _c("h3", [
              _vm._v(
                "Before sending messages to your sports " +
                  _vm._s(_vm.$starLabel) +
                  ", please accept our "
              ),
              _c(
                "a",
                { attrs: { href: _vm.bookingTncLink(), target: "_blank" } },
                [_vm._v("terms and conditions")]
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "You must only communicate with the sports " +
                    _vm._s(_vm.$starLabel) +
                    " via the " +
                    _vm._s(this.clientName) +
                    " messaging portal. You can share files within the portal, but our system filters out phone numbers and emails."
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "You must not ask the sports " +
                    _vm._s(_vm.$starLabel) +
                    " to do anything that is not included in your booking. If any changes need to be made to your booking (e.g. dates, deliverables etc.), you must notify the " +
                    _vm._s(this.clientName) +
                    " team"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "To avoid confusion, please keep your messages focused on important matters relating to your request only"
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      !_vm.$vlastMode && (_vm.$userIsTalent || _vm.$userIsManager)
        ? _c("div", [
            _c("h3", [
              _vm._v(
                "Before messaging the client, here's a few important things to remember:"
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c("li", [
                _vm._v(
                  "You must only communicate with the client via the " +
                    _vm._s(_vm.clientName) +
                    " messaging portal. You can share files within the portal, but our system filters out phone numbers and emails. This helps us manage the request and protect your interests."
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "If the client asks you to do anything that is not included in the booking, please contact the " +
                    _vm._s(_vm.clientName) +
                    " team"
                ),
              ]),
              _vm._v(" "),
              _c("li", [_vm._v("Please respond as promptly as you can")]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "Keep the discussion focused on the details of your request"
                ),
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(
                  "If you're unsure of anything, call the " +
                    _vm._s(_vm.clientName) +
                    " team on "
                ),
                _c(
                  "a",
                  {
                    attrs: { href: "tel:1300657601" },
                    on: { click: _vm.trackCallClick },
                  },
                  [_vm._v("1300 657 601")]
                ),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("ladda-button", {
        staticClass: "btn btn-info btn-sm m-t-sm",
        attrs: { click: _vm.handleAcceptTermsCallback },
        domProps: {
          innerHTML: _vm._s(_vm.$vlastMode ? `Get Started` : `Accept Terms`),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }